import styled from 'styled-components';
import { toRem } from '@marriott/shared/mi-helper-utils';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  min-height: ${toRem(46)};
  padding-inline: ${toRem(6)};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: start;
`;

export const TrailingIconTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacers?.spacers?.[1] ?? '0.25rem'};
`;
